import ScrollTabs from '@/components/ScrollTabs';
import { Outlet } from 'react-router-dom';

const ProfileLayout = () => {
  return (
    <div>
      <ScrollTabs />
      <Outlet />
    </div>
  );
};

export default ProfileLayout;
